export default "__VITE_ASSET__BcCd$mB7__"